import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getGroupList = async (e_line, cur_page) => {
  const requestBody = {
    e_line,
    cur_page,
  };
  try {
    const response = await httpRequest("post", `${URL}/groupList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getGroupSortbyIdList = async (e_line, cur_page) => {
  const requestBody = {
    e_line,
    cur_page,
  };
  try {
    const response = await httpRequest("post", `${URL}/groupSortbyIdList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getGroup = async (group_id) => {
  const requestBody = {
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/group`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertGroup = async (requestBody) => {
  try {
    const response = await httpRequest(
      "post",
      `${URL}/insertGrpInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateGroup = async (data) => {
  const requestBody = {
    group_nm: data.group_nm,
    group_id: data.group_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/updateGrpInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteGroup = async (group_id) => {
  const requestBody = {
    group_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/deleteGrpInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
